import { render, staticRenderFns } from "./MessageComponent.vue?vue&type=template&id=ca9dc93a&scoped=true"
import script from "./MessageComponent.vue?vue&type=script&lang=js"
export * from "./MessageComponent.vue?vue&type=script&lang=js"
import style0 from "./MessageComponent.vue?vue&type=style&index=0&id=ca9dc93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9dc93a",
  null
  
)

export default component.exports